import { render } from "./App.vue?vue&type=template&id=6cf513ba"
const script = {}

import "./App.vue?vue&type=style&index=0&id=6cf513ba&lang=css"

import exportComponent from "/home/jroy/src/personal/www/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__